function Designer() {
	// A page to display designs and keep the designs so we can have a reference page.
	// Just give className='hidden' to the div to make the ones you don't need invisible.
	// add a react page to the design pieces folder.
	// add an import xxx from '../components/design pieces/xxx' and <div><xxx /></div> to display
	return <div>Designer Display</div>
}

export default Designer
